import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid2 as Grid,
  Typography,
  Divider,
  IconButton,
  Toolbar,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import Alert from '@mui/material/Alert';
import { ExpandMore, ArrowBack } from '@mui/icons-material';
import * as mobileHelper from '../../../helpers/mobile';
import delayCodes from './delayCodesData';
import styles from '../styles';

const useStyles = makeStyles(theme => ({
  codesDialogHeading: {
    marginLeft: theme.spacing(2),
  },
  codesContent: {
    padding: 0,
    paddingBottom: theme.spacing(3),
  },
  codesDetails: {
    display: 'block',
    padding: 0,
  },
  codeRow: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.divider,
    },
  },
  codeColumn: {
    textAlign: 'center',
  },
  codesToolbar: {
    padding: 0,
  },
  codesDialogTitle: {
    padding: 0,
  },
  codeDescription: {
    paddingRight: theme.spacing(2),
  },
  codesInfoRow: {
    margin: theme.spacing(2),
    background: theme.palette.grey[100],
    color: theme.palette.text.primary,
    '& svg': {
      color: theme.palette.primary.main,
    },
  },
}));

const DelayCodesDialog = ({ isOpen, onClose, onSelect }) => {
  const classes = useStyles();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullScreen={mobileHelper.isPortrait()}
    >
      <DialogTitle className={classes.codesDialogTitle}>
        <Toolbar className={classes.codesToolbar} variant="dense">
          <IconButton
            onClick={onClose}
            color="inherit"
            aria-label="close"
            size="large"
          >
            <ArrowBack />
          </IconButton>
          <Typography className={classes.codesDialogHeading} variant="h6">
            Standard IATA delay codes
          </Typography>
        </Toolbar>
      </DialogTitle>
      <Divider />
      <DialogContent className={classes.codesContent}>
        {delayCodes?.map(section => {
          return (
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMore />}>
                {`${section.number} - ${section.title}`}
              </AccordionSummary>
              <AccordionDetails className={classes.codesDetails}>
                {section.info && (
                  <>
                    <Alert
                      className={classes.codesInfoRow}
                      variant="standard"
                      severity="info"
                    >
                      {section.info}
                    </Alert>
                    <Divider />
                  </>
                )}
                {section.codes?.map(item => (
                  <>
                    <Grid
                      className={classes.codeRow}
                      container
                      alignItems="center"
                      onClick={() => {
                        onSelect(item.code);
                        onClose();
                      }}
                    >
                      <Grid className={classes.codeColumn} size={{ xs: 2 }}>
                        <Typography variant="subtitle2">{item.code}</Typography>
                      </Grid>
                      <Grid
                        className={classes.codeDescription}
                        size={{ xs: 10 }}
                      >
                        {item.description}
                      </Grid>
                    </Grid>
                    <Divider orientation="horizontal" />
                  </>
                ))}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </DialogContent>
    </Dialog>
  );
};

export default withStyles(styles)(DelayCodesDialog);
